<template lang="html">
  <b-container>
    <b-row>
      <b-col md="4" offset-md="4" class="mt-5">
        <b-form @submit="login">
          <b-form-group
            id="exampleInputGroup1"
            label="Username:"
            label-for="exampleInput1"
            description="We'll never share your email with anyone else."
          >
            <b-form-input
              id="exampleInput1"
              v-model="username"
              type="text"
              required
              placeholder="Enter username"
            />
          </b-form-group>

          <b-form-group
            id="exampleInputGroup2"
            label="Password:"
            label-for="password_input"
          >
            <b-form-input
              id="password_input1"
              v-model="password"
              type="password"
              required
              placeholder="Enter password"
            />
          </b-form-group>
          <b-button type="submit" variant="primary">
            Login
          </b-button>
        </b-form>
        <!--
    <p v-show="$store.state.login_error" class="mt-5 alert alert-danger">
      Error: {{ $store.state.login_error_message }} Please try again. If
      problems persist,
      <b-link :to="{ name: 'password_reset' }">
        go to the password reset page.
      </b-link>
    </p>
    <p v-show="!$route.meta.login_required" class="mt-5">
      Don't have an account?
      <b-link :to="{ name: 'trial' }">
        Go to sign-up page.
      </b-link>
    </p>
    <p class="mt-5">
      Problems logging in?
      <b-link :to="{ name: 'password_reset' }">
        Go to password reset page.
      </b-link>
    </p>
  -->
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import axios from "axios";
import Storage from "store2";
export default {
  name: "Login",
  data() {
    return {
      username: "",
      password: ""
    };
  },
  methods: {
    login(evt) {
      var _v = this;
      evt.preventDefault();
      var apiRoot = "https://api-py38.ukeability.org";
      axios
        .post(`${apiRoot}/api-token-auth/`, {
          username: this.username,
          password: this.password
        })
        .then(response => {
          console.log(response);
          if (response.status == 200) {
            Storage.set("_t", response.data.token);
            Storage.set("username", _v.username);
          }
          _v.$store.commit("set_user_as_authorized");
        })
        .catch(response => {
          console.log(response);
        });
    }
  }
};
</script>

<style lang="css" scoped></style>
